import * as React from 'react';

export const AddTree = () => (
    <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M19 9a1 1 0 1 0 0-2v2ZM5 7a1 1 0 0 0 0 2V7Zm0 4a1 1 0 1 0 0 2v-2Zm9 2a1 1 0 1 0 0-2v2Zm-3 4a1 1 0 1 0 0-2v2Zm-6-2a1 1 0 1 0 0 2v-2Zm10 0a1 1 0 1 0 0 2v-2Zm6 2a1 1 0 1 0 0-2v2Zm-2-4a1 1 0 1 0-2 0h2Zm-2 6a1 1 0 1 0 2 0h-2Zm2-12H5v2h14V7ZM5 13h9v-2H5v2Zm6 2H5v2h6v-2Zm4 2h6v-2h-6v2Zm2-4v6h2v-6h-2Z"
            fill="#353535"
            opacity={0.8}
        />
    </svg>
);
